import validate from "/app/node_modules/nuxt/dist/pages/runtime/validate.js";
import auth_45global from "/app/middleware/auth.global.ts";
import permission_45global from "/app/middleware/permission.global.ts";
import track_45user_45global from "/app/middleware/trackUser.global.ts";
import manifest_45route_45rule from "/app/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  auth_45global,
  permission_45global,
  track_45user_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "job-edit": () => import("/app/middleware/jobEdit.ts")
}